"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchFiles = exports.buildResponsePayload = void 0;

var _immutable = require("immutable");

var _logging = require("../utils/logging");

var _ActionTypes = require("./ActionTypes");

var _Constants = require("../Constants");

var _pick = _interopRequireDefault(require("../utils/pick"));

var FileSearchApi = _interopRequireWildcard(require("../api/FileSearch"));

var _FileDetails = require("../selectors/FileDetails");

var FILE_PASSTHROUGH_ATTRS = ['id', 'name', 'size', 'extension', 'encoding', 'url', 'height', 'width', 'category', 'archived'];
var FOLDER_PASSTHROUGH_ATTRS = ['id', 'name', 'hidden', 'category'];

var transformFileItem = function transformFileItem(attrs) {
  return (0, _immutable.fromJS)(Object.assign({}, (0, _pick.default)(attrs, FILE_PASSTHROUGH_ATTRS), {
    portal_id: attrs.portalId,
    folder_id: attrs.folderId || null,
    updated: attrs.updatedAt,
    created: attrs.createdAt,
    full_path: attrs.fullPath,
    type: attrs.fileType,
    cloud_key: attrs.cloudKey,
    friendly_url: attrs.url,
    default_hosting_url: attrs.url,
    meta: {
      allows_anonymous_access: attrs.allowsAnonymousAccess
    }
  }));
};

var transformFolderItem = function transformFolderItem(attrs) {
  return (0, _immutable.Map)(Object.assign({}, (0, _pick.default)(attrs, FOLDER_PASSTHROUGH_ATTRS), {
    portal_id: attrs.portalId,
    parent_folder_id: attrs.folderId || null,
    updated: attrs.updatedAt,
    created: attrs.createdAt,
    full_path: attrs.fullPath
  }));
};

var buildResultFileItems = function buildResultFileItems(objects) {
  return (0, _immutable.List)(objects.map(transformFileItem));
};

var buildResultFolderItems = function buildResultFolderItems(objects) {
  return (0, _immutable.OrderedMap)(objects.map(function (attrs) {
    return [attrs.id, transformFolderItem(attrs)];
  }));
};

var buildResponsePayload = function buildResponsePayload(resp) {
  var objectCategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Constants.ObjectCategory.FILE;
  var objects = objectCategory === _Constants.ObjectCategory.FILE ? buildResultFileItems(resp.results) : buildResultFolderItems(resp.results);
  return (0, _immutable.Map)(Object.assign({}, resp, {
    objects: objects
  })).delete('results');
};

exports.buildResponsePayload = buildResponsePayload;

var mergeRecentlyUploadedFiles = function mergeRecentlyUploadedFiles(data, recentlyUploadedFiles, currentFolderId, options) {
  var fileIds = data.get('objects').map(function (f) {
    return f.get('id');
  });
  var missingRecentlyUploadedFiles = recentlyUploadedFiles.filter(function (f) {
    return !fileIds.includes(f.get('id'));
  }).toList();

  if (missingRecentlyUploadedFiles.isEmpty()) {
    return data;
  }

  var now = new Date().getTime();
  (0, _logging.reportMessage)("Splicing in recently uploaded files to ES response", {
    currentFolderId: currentFolderId,
    options: options,
    esFileIds: fileIds.toArray(),
    uploadedFileIds: missingRecentlyUploadedFiles.map(function (f) {
      return {
        id: f.get('id'),
        elapsed: now - f.get('clientUploadedAt')
      };
    }).toArray()
  });
  return data.merge({
    objects: data.get('objects').concat(missingRecentlyUploadedFiles),
    total: data.get('total') + missingRecentlyUploadedFiles.size
  });
};

var searchFilesAttempted = function searchFilesAttempted(query, fetchingMore) {
  return {
    type: _ActionTypes.SEARCH_FILES_ATTEMPTED,
    status: _Constants.RequestStatus.PENDING,
    query: query,
    fetchingMore: fetchingMore
  };
};

var searchFilesSuccess = function searchFilesSuccess(query, data, fetchingMore) {
  return {
    type: _ActionTypes.SEARCH_FILES_SUCCESS,
    status: _Constants.RequestStatus.SUCCEEDED,
    query: query,
    data: data,
    fetchingMore: fetchingMore
  };
};

var searchFilesFailed = function searchFilesFailed(query, error, fetchingMore) {
  return {
    type: _ActionTypes.SEARCH_FILES_FAILED,
    status: _Constants.RequestStatus.FAILED,
    query: query,
    error: error,
    fetchingMore: fetchingMore
  };
};

var searchFiles = function searchFiles() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fetchingMore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch, getState) {
    var folderId = options.folder_id;
    var recentlyUploadedFiles = (0, _FileDetails.getRecentlyUploadedFiles)(getState(), {
      folderId: folderId
    });
    dispatch(searchFilesAttempted(options, fetchingMore));
    var shouldMergeRecentlyUploadedFiles = !fetchingMore && !options.search && !options.archived;
    FileSearchApi.fetchFilesFromSearch(options).then(function (data) {
      data = buildResponsePayload(data);

      if (shouldMergeRecentlyUploadedFiles) {
        data = mergeRecentlyUploadedFiles(data, recentlyUploadedFiles, folderId, options);
      }

      dispatch(searchFilesSuccess(options, data, fetchingMore));
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: _ActionTypes.SEARCH_FILES_FAILED
      });
      dispatch(searchFilesFailed(options, err, fetchingMore));
    });
  };
};

exports.searchFiles = searchFiles;